import { observable, action } from 'mobx'

type NotificationMenuObj = {
    key: string
    countBadge: number
}

export default class {
    @observable notificationMenu: NotificationMenuObj[] = []
    @action setNotificationMenu = (key: string, notificationMenu: NotificationMenuObj[]) => {
        const indexNotificationMenu = this.notificationMenu.findIndex((item) => item.key === key)

        if (indexNotificationMenu === -1) {
            this.notificationMenu = [...this.notificationMenu, ...notificationMenu]
        } else {
            this.notificationMenu[indexNotificationMenu] = notificationMenu[0]
        }
    }
}
